export const data = {
    id: "",
    from_date: "",
    to_date: "",
    use_impact: false
}